import {DataGrid} from '@material-ui/data-grid';
import {useState, useMemo} from 'react';
import {ItemDetails} from './ItemDetails';


const columns = [


    {
        field: 'Categorie', width: 200,
        valueGetter: (p) => {
            return `
                ${p.row.Categorie?.Label || ''}
                `
        }
    },
    {
        field: 'SubCategorie', width: 200,
        valueGetter: (p) => {
            return `
            ${p.row.Categorie?.SubCategorie ? p.row.Categorie?.SubCategorie?.Label : '' || ''}
            `
        }
    },
    {field: 'InternalId', width: 150},
    {field: 'UPC', width: 150},
    {field: 'Name', width: 550},
    {field: '_price', headerName: "SellPrice", width: 100},
    {
        field: 'IsProductValidated', headerName: "Status",
        width: 100
    }
];


const ItemList = (props) => {
    const [showModal, setShowModal] = useState(false)
    const [selectItem, setSelectItem] = useState({})
    const {items, isLoading} = props;
    // console.log(items)


    const list = useMemo(() => items?.map(one => ({...one, _price: one?.SalePriceMutator?.NewSalePrice, UPC: one?.UPC })) || [], [items])

    // console.log(list)
    const handleSelection = (row) => {
        setSelectItem(row)
        setShowModal(true)
    }


    return (
        <div style={{height: 600, width: '100%'}}>
            {showModal && <ItemDetails open={showModal} setOpen={setShowModal} item={selectItem}/>}
            {
                items &&
                <DataGrid rows={list}
                          onRowClick={(e) => handleSelection(e.row)}
                          loading={isLoading}
                          columns={columns}/>
            }
        </div>
    )
}

export default ItemList;